<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import TimeOffDetail from '../../../../../time-off/components/TimeOffDetail.vue'
import { TimeOffRequestID } from '../../../../../time-off/models/timeOffRequest'

definePage({
    props: true,
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})

const {
  id,
} = defineProps<{
    id: TimeOffRequestID
}>()
</script>

<template>
  <TimeOffDetail
    :id="id"
  />
</template>